module.exports = __webpack_public_path__ + "images/ace044ab.png";